export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sticky_note.e0f5e13b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};